export const roles = ['client', 'admin', 'doctor', 'clinic_owner'];

export const userTypeTranslations = {
  individual: 'Fizičko lice',
  company: 'Pravno lice',
};

export const userStatusTranslations = {
  active: 'Aktivan',
  suspended: 'Suspendovan',
  archived: 'Arhiviran',
  pending_verification: 'Čeka verifikaciju',
  pending_admin_verification: 'Čeka verifikaciju',
  pre_registration: 'Registracija nedovršena',
  rejected: 'Odbijen',
};

export const userRoleTranslations = {
  user: 'Korisnik',
  manager: 'Menadžer',
  admin: 'Admin',
};
